import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import { Theme } from '../../config/theme';
import { updateAppState } from '../../actions/applicationState';
import { sendReviewRequest } from '../../actions/user';
import { getMember } from '../../actions/profile';
import { ASSET_BASE_URL } from '../../utils/Api';

import Review from '../Review';
import ReviewModal from '../ReviewModal';

export default class Reviews extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stars: 3,
      review_submitted: false,
      errors: {
        public_review: false,
      },
    };
    this.submitReview = this.submitReviewHandler.bind(this);
    this.setRatingHandler = this.setRating.bind(this);
    this.updateTextFieldHandler = this.updateTextField.bind(this);

    this.openHandler = props.openHandler.bind(this);
    this.pushReview = props.pushReviewHandler.bind(this);
    this.canReview = props.canReview;
    this.reviews = props.reviews;
  }

  getUserImage(review) {
    if (review.reviewer_image_url && review.reviewer_image_url.length > 10) {
      return ASSET_BASE_URL + '/' + review.reviewer_image_url;
    }

    return '/images/default_profile.jpg';
  }

  getMemberFirstName(reviewer) {
    const fullName = reviewer.split(' ');
    return fullName[0];
  }

  getUserProfileLink(review) {
    return '/profile/' + review.reviewer_id;
  }

  setRating(rating) {
    this.setState({
      stars: rating,
    });
  }

  updateTextField(key, value) {
    const updatedState = {
      [key]: value,
    };

    this.setState(updatedState);

    setTimeout(() => {
      this.validateForm();
      if (this.state.errors[key]) {
        this.validateForm();
      }
    }, 10);
  }

  pushNewReview() {
    this.props.dispatch(updateAppState({
      loading: true,
    })).then(() => {
      this.props.dispatch(getMember(this.props.match.params.id,
        this.props.user.access_token)).then((response) => {
          const reviews = response.reviews;
          // pushes new review prop into profile state
          reviews.map(review => (
            this.props.pushReviewHandler(review)
          ));
        });
    }, (err) => {
      console.log(err); // eslint-disable-line no-console
      this.props.dispatch(updateAppState({
        loading: false,
      }));
    });
  }

  submitReviewHandler() {
    // Initiate loading sequence
    this.props.dispatch(updateAppState({
      loading: true,
    })).then(() => {
      // Continue loading during request
      this.props.dispatch(updateAppState({
        loading: true,
      }));
      // Dispatching review request
      this.props.dispatch(
        sendReviewRequest({
          id: this.props.match.params.id,
          type: this.props.user.subscription,
          review: this.state.public_review,
          rating: this.state.stars,
        }, this.props.user.access_token),
      ).then(() => {
        // Manage state with response
        this.pushNewReview();
        this.setState({
          review_submitted: true,
        });
        this.props.dispatch(updateAppState({
          loading: false,
        }));
      }, (err) => {
        console.log(err); // eslint-disable-line no-console
        this.props.dispatch(updateAppState({
          loading: false,
        }));
      });
    });
  }

  validateForm() {
    const errors = {};

    if (this.state.public_review.length > 200) {
      errors.public_review = 'You have exceeded the (200) character limit';
    } else {
      errors.public_review = false;
    }

    let formErrors = false;

    for (const key in errors) { //eslint-disable-line
      if (errors[key] !== null) {
        formErrors = true;
      }
    }

    if (formErrors) {
      this.setState({
        errors,
      });

      return false;
    }

    return true;
  }

  countPublicReviews(reviews) {
    let total = 0;
    reviews.map((review) => { // eslint-disable-line
      if (review.isPublicReview) {
        total++; // eslint-disable-line
      }
    });

    if (total === 1) {
      return total + ' Public Review';
    }

    return total + ' Public Reviews';
  }

  render() {
    return (
      <div className={css(styles.container)}>
        <p className={css(styles.review_note)}>
          Feedback enables transparency, creates trust and keeps our community safe.
        </p>
        <div className={css(styles.heading)}>
          <div className={css(styles.count)}>
            {
              this.countPublicReviews(this.props.reviews)
            }
          </div>
          {
            this.props.canReview === true && !this.state.review_submitted ? (
              <div
                onClick={this.openHandler}
                className={css(styles.add)}
                role="button"
                tabIndex={0}
              >
                Write a review
              </div>
            ) : false
          }
          {this.props.open}
        </div>
        <div className={css(styles.reviews)}>
          {
            this.props.reviews.length ? this.props.reviews.map(review => (
              <Review
                photo={this.getUserImage(review)}
                profileLink={this.getUserProfileLink(review)}
                name={this.getMemberFirstName(review.reviewer)}
                date={review.created}
                isPublic={review.isPublicReview}
                >
                <p>
                  {review.reviewer_comment}
                </p>
              </Review>
            )) : false
          }
        </div>
        <ReviewModal
          openHandler={this.props.openHandler}
          submitReviewHandler={this.submitReview}
          setRatingHandler={this.setRatingHandler}
          updateTextField={this.updateTextFieldHandler}
          reviewSubmitted={this.state.review_submitted}
          updatedStars={this.state.stars}
          formError={this.state.errors.public_review}
          open={this.props.open}
        />
      </div>
    );
  }
}

Reviews.propTypes = {
  open: PropTypes.bool.isRequired,
  openHandler: PropTypes.func.isRequired,
  pushReviewHandler: PropTypes.func.isRequired,
  reviews: PropTypes.array.isRequired,
  canReview: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

const styles = StyleSheet.create({
  container: {

  },
  heading: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 20,
    fontFamily: Theme.font_family_primary,
    fontWeight: Theme.font_weight_primary,
  },
  count: {
    fontSize: 15,
  },
  add: {
    fontSize: 18,
    color: Theme.turquoise,
    cursor: 'pointer',
    outline: 'none',
  },
  review_note: {
    padding: '10px 0 30px',
    fontSize: 16,
    fontFamily: Theme.font_family_primary,
  },
});



// WEBPACK FOOTER //
// ./src/components/Reviews/index.js